import { render, staticRenderFns } from "./OrderState.vue?vue&type=template&id=194d4497&"
import script from "./OrderState.vue?vue&type=script&lang=js&"
export * from "./OrderState.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports